export default __webpack_public_path__ + "static/media/Delivery.2832f125.svg";